export default __webpack_public_path__ + "static/media/video.1b53bba1.svg";